export const products = [
  {
    id: 1,
    name: "Shampoo de miel",
    category: "Cabello",
    description: "Las propiedades de la miel orgánica que en conjunto con la vitamina E, la proteína de trigo y el aceite de argán trabajan para brindarte un producto 100% natural que nutrirá tu cabello dándole el brillo y la suavidad que se merece.",
    ingredients: ["Miel orgánica", "Vitamina E", "Proteína de trigo", "Aceite de argán"],
    variants: [
      { size: "500ml", price: 220 },
      { size: "950ml", price: 420 }
    ],
    image: "https://images.unsplash.com/photo-1775126454592-692fc7c122c0",
    featured: true
  },
  {
    id: 2,
    name: "Acondicionador de miel",
    category: "Cabello",
    description: "Las propiedades de la miel orgánica que en conjunto con la vitamina E, la proteína de trigo y el aceite de argán trabajan para brindarte un producto 100% natural que nutrirá tu cabello dándole el brillo y la suavidad que se merece.",
    ingredients: ["Miel orgánica", "Vitamina E", "Proteína de trigo", "Aceite de argán"],
    variants: [
      { size: "500ml", price: 220 },
      { size: "950ml", price: 420 }
    ],
    image: "https://images.unsplash.com/photo-1775126454577-4846f3e55cc5",
    featured: true
  },
  {
    id: 3,
    name: "Serúm capilar",
    category: "Cabello",
    description: "Utilizamos las propiedades de la proteína de seda que, en conjunto con la vitamina E y los aceites naturales de amla, marula y bergamota, trabajan para brindarte un producto 100% natural que nutrirá tu cabello dándole el brillo y la sedosidad que merece.",
    ingredients: ["Proteína de seda", "Vitamina E", "Aceite de amla", "Aceite de marula", "Aceite de bergamota"],
    variants: [
      { size: "50ml", price: 300 }
    ],
    image: "https://images.unsplash.com/photo-1532413992378-f169ac26fff0",
    featured: true
  },
  {
    id: 4,
    name: "Gel corporal de menta, eucalipto y miel",
    category: "Corporal",
    description: "Utilizamos las propiedades de la miel orgánica que, en conjunto con la vitamina E y los aceites esenciales de menta y eucalipto, trabajan para brindarte un producto 100% natural que limpiará tu piel, dándole frescura y suavidad.",
    ingredients: ["Miel orgánica", "Vitamina E", "Aceite esencial de menta", "Aceite esencial de eucalipto"],
    variants: [
      { size: "500ml", price: 220 },
      { size: "950ml", price: 420 }
    ],
    image: "https://images.unsplash.com/photo-1775126454592-692fc7c122c0",
    featured: false
  },
  {
    id: 5,
    name: "Shampoo íntimo",
    category: "Cuidado íntimo",
    description: "Utilizamos las propiedades de la miel orgánica que en conjunto con la vitamina E, extractos naturales de sávila, caléndula, tomillo e ylang ylang trabajan para brindarte una limpieza suave y delicada.",
    ingredients: ["Miel orgánica", "Vitamina E", "Extracto de sávila", "Caléndula", "Tomillo", "Ylang ylang"],
    variants: [
      { size: "250ml", price: 120 }
    ],
    image: "https://images.unsplash.com/photo-1775126454577-4846f3e55cc5",
    featured: false
  },
  {
    id: 6,
    name: "Crema para peinar sin enjuague en spray",
    category: "Cabello",
    description: "Utilizamos las propiedades de la miel orgánica que, en conjunto con la proteína de trigo, vitamina E, queratina, proteína de seda, aceite de monoi y el aceite de argán, trabajan para brindarte un producto 100% natural que nutrirá tu cabello dándole el brillo y la suavidad que se merece.",
    ingredients: ["Miel orgánica", "Proteína de trigo", "Vitamina E", "Queratina", "Proteína de seda", "Aceite de monoi", "Aceite de argán"],
    variants: [
      { size: "250ml", price: 180 }
    ],
    image: "https://images.unsplash.com/photo-1532413992378-f169ac26fff0",
    featured: false
  },
  {
    id: 7,
    name: "Exfoliante corporal de lavanda/té blanco o verbena",
    category: "Corporal",
    description: "Utilizamos las propiedades de la miel orgánica, que en conjunto con los tensoactivos y aceites naturales de coco, arroz, cacao y argán, así como glicerina, extracto de aloe vera y azúcar, trabajan para limpiar y exfoliar todo tu cuerpo dejándolo limpio e hidratado con un delicioso aroma.",
    ingredients: ["Miel orgánica", "Aceite de coco", "Aceite de arroz", "Aceite de cacao", "Aceite de argán", "Glicerina", "Extracto de aloe vera", "Azúcar"],
    variants: [
      { size: "250ml", price: 220 }
    ],
    image: "https://images.unsplash.com/photo-1775126454592-692fc7c122c0",
    featured: false
  },
  {
    id: 8,
    name: "Kit de viaje",
    category: "Kits",
    description: "Nuestro kit de viaje reúne tus esenciales favoritos en presentación práctica para acompañarte a donde vayas. Formulado con ingredientes naturales y hecho artesanalmente, limpia, nutre y protege tu piel y cabello sin químicos agresivos.",
    ingredients: ["4 productos de 90ml c/u"],
    variants: [
      { size: "4 x 90ml", price: 220 }
    ],
    image: "https://images.unsplash.com/photo-1749856727296-481414df24e5",
    featured: true
  }
];

export const faqs = [
  {
    question: "¿Los productos son realmente 100% naturales?",
    answer: "Sí, todos nuestros productos están hechos artesanalmente con ingredientes naturales. No contienen parabenos, sulfatos ni químicos agresivos. Utilizamos miel orgánica como ingrediente principal junto con aceites esenciales y extractos naturales."
  },
  {
    question: "¿Cuánto tiempo dura cada producto?",
    answer: "La duración depende de la frecuencia de uso. En promedio, un frasco de 500ml puede durar entre 2-3 meses con uso regular. Nuestros productos son concentrados, por lo que necesitas menos cantidad en cada aplicación."
  },
  {
    question: "¿Son aptos para todo tipo de cabello?",
    answer: "Sí, nuestros productos son formulados para todo tipo de cabello. Los ingredientes naturales se adaptan a las necesidades específicas de cada persona, desde cabello seco hasta graso."
  },
  {
    question: "¿Hacen envíos a toda la República Mexicana?",
    answer: "Sí, realizamos envíos a toda la República Mexicana. El tiempo de entrega varía según tu ubicación, generalmente entre 3-7 días hábiles."
  },
  {
    question: "¿Tienen certificaciones orgánicas?",
    answer: "Trabajamos con proveedores certificados de miel orgánica y aceites esenciales. Nuestros productos son artesanales y están elaborados con los más altos estándares de calidad."
  },
  {
    question: "¿Puedo devolver un producto si no me gusta?",
    answer: "Sí, aceptamos devoluciones dentro de los primeros 15 días si el producto no ha sido abierto. Tu satisfacción es nuestra prioridad."
  }
];
